import { Card, CardBody, Center, LinkBox, LinkOverlay, Text } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { Link as ReactRouterLink } from 'react-router-dom'
import styles from './ImportantNowCard.module.scss'

interface ImportantNowCardProps {
  navTo: string
  hide?: boolean
  navMessage?: string
  className?: string
  children?: React.ReactNode
  'data-qa'?: string
  winType: string
  tracking: { guid: string; ui_context: string; descriptor: string }
  svgImage?: any
}

export const ImportantNowCard: React.FC<ImportantNowCardProps> = ({
  tracking,
  navTo,
  hide,
  winType,
  navMessage,
  children,
  svgImage: WinImage
}) => {
  const MSG = defineMessages({
    getMoreDetails: {
      id: 'ImportantNow.card.cta',
      defaultMessage: 'Get more details'
    }
  })

  const intl = useIntl()

  if (hide) {
    return null
  }

  return (
    <LinkBox className={styles.linkBox}>
      <Card className={styles.card} minH={'275px'} maxW={'300px'} m='auto' height={`100%`}>
        <CardBody>
          <Center m={'auto'}>{WinImage && <WinImage />}</Center>
          <Text pt={3} data-qa='win-card-body-text'>
            {children}
          </Text>
          <LinkOverlay tracking={tracking} as={ReactRouterLink} to={navTo} className={styles.link}>
            <Text fontWeight={'bold'} color={'primary'}>
              {navMessage ? navMessage : intl.formatMessage(MSG.getMoreDetails)}
            </Text>
          </LinkOverlay>
        </CardBody>
      </Card>
    </LinkBox>
  )
}
